// extracted by mini-css-extract-plugin
export default {"tooltipError":"Hc3Y9hFEU0EPegz56qs6","input":"mTzvmEP02Qek9W_bKoKN"};